// While a /rollup snapshot is still being built (`snapshot.state === 'pending'`), call `refetch` again
// after `intervalMs`. Each new response re-arms the timer; any other response stops it. `refetch` must
// be stable (a useCallback), or every render would restart the wait.
import { useEffect } from 'react';

export const isSnapshotPending = (body) => body?.snapshot?.state === 'pending';

export default function usePendingPoll(body, refetch, intervalMs = 30000) {
  useEffect(() => {
    if (!isSnapshotPending(body)) return undefined;
    const timer = setTimeout(refetch, intervalMs);
    return () => clearTimeout(timer);
  }, [body, refetch, intervalMs]);
}
